// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1QkJb","insightsList":"newBusinessInsightsMenu_insightsList__1k3yA","active":"newBusinessInsightsMenu_active__17IvM"};